import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { Coverage } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface GetCoveragesParams extends DefaultHttpHeaders {
  projectQuoteId: string;
  riskId: string;
  companyId?: string;
  version: string;
}

@Injectable()
export class GetCoveragesService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Obtain project coverages
   * Obtain project coverages
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Project/getProjectCoverages
   */
  getCoverages(params: GetCoveragesParams): Observable<Coverage[]> {
    const pathParams = {
      projectQuoteId: params.projectQuoteId,
      riskId: params.riskId,
    };
    const queryParams = {
      companyId: params.companyId,
      version: params.version,
    };

    return this.get<Coverage[]>({
      suffix: `/home/project/${pathParams.projectQuoteId}/risk/${pathParams.riskId}/coverages`,
      queryParams,
      authenticationType: 'jwt',
    });
  }
}
